import styled from 'styled-components';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { TextColors, Fonts, Spacings } from '../../../styleConstants';

const H3 = styled.h3`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H3};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  ${({ theme }) => `${theme.breakpoints.down('tablet')} {
      font-size: 24px;
    };`}
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
    @media (max-width: 47.95em) {
    font-size: 22px;
  }
`;

export default H3;

H3.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H3.defaultProps = {
  color: TextColors.BLACK,
  lineClamp: null
};
